<template>
  <div class="v-activity-lesson">
    <sheet>
      <div class="article-wrap">
        <loading v-if="isLoading" />
        <brief-apply :articles="articles" type="activity-lesson" v-else/>
      </div>
      <div class="pagination-wrap">
        <pagination :pager="pager" @handlePagination="handlePagination" />
      </div>
    </sheet>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  reactive,
  watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import BriefApply from '@/components/Global/BriefApply.vue';
import Pagination from '@/components/Global/Pagination.vue';
import { getViewEventsAPI } from '@/api/events';
import useRequest from '@/hooks/useRequest';

export default defineComponent({
  name: 'ActivityLessons',
  components: {
    BriefApply,
    Pagination,

  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const pager = reactive({
      pageIndex: route.query?.pageIndex || 1,
      totalPage: 7,
    });

    const { response, request, isLoading } = useRequest(getViewEventsAPI);
    request(pager);

    const articles = ref([]);

    const getViewEvents = async (res) => {
      try {
        const {
          result, status,
        } = res.value;

        if (status) {
          articles.value = result.data;
          pager.totalPage = result.pageCount;

          return;
        }
        articles.value = [];
      } catch (e) {
        console.log('e', e);
        articles.value = [];
      }
    };

    const handlePagination = (targetPage) => {
      pager.pageIndex = targetPage;

      router.push({
        name: 'activity-lessons',
        query: {
          pageIndex: pager.pageIndex,
        },
      });

      request(pager);
    };

    watch(response, () => {
      getViewEvents(response);
    });

    return {
      // activeTabKey,
      // tabsConfig,
      // articlesMock,
      pager,
      articles,
      handlePagination,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/tableWrap.scss';
</style>
